import React, { useCallback, useEffect } from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { Person, Chip } from '@arnsbogroup/react-voicearchive'
import { useParams } from 'react-router-dom'
import useApi from 'hooks/useApi'
import Chat from 'components/Chat'

export default ({ task, order, setTabChip }) => {
  const [supplierMsgs, supplierMsgsLoading,, loadSupplierMsgs] = useApi(`/message/supplierCoordinatorThreadForTaskId?taskId=${task.uid}`)
  const [customerMsgs, customerMsgsLoading,, loadCustomerMsgs] = useApi(`/message/customerCoordinatorThreadForTaskId?taskId=${task.uid}`)

  useEffect(() => {
    setTabChip(<Chip>{ supplierMsgs?.length }</Chip>)
  }, [supplierMsgs, customerMsgs])

  const getHandler = useCallback((endpoint, handler) =>
    (msg, subject = '') => {
      fetch(`/message/${endpoint}`,{
        method: 'POST',
        body: new URLSearchParams({
          msg,
          subject,
          taskId: task.uid,
        })
      })
        .then(handler)
        .catch((error) => toastr.error(error))
    },
    []
  )

  const onCustomerMsg = useCallback(getHandler('sendCustomerMessage', loadCustomerMsgs), [])
  const onSupplierMsg = useCallback(getHandler('sendSupplierMessage', loadSupplierMsgs), [])

  return (
    <div className="flex justify-between divide-x divide-gray-200">
      <div className="w-1/2">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <div className="flex space-x-2">
            <Person {...order.contacts.contact} />
            { order.contacts.cccontact &&
              <Person {...order.contacts.cccontact} />
            }
          </div>
          <Chip>Contacts</Chip>
        </div>

        <Chat
          messages={customerMsgs || []}
          onSend={onCustomerMsg}
        />
      </div>

      <div className="w-1/2">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <Person
            {...task.supplier}
            name={task.supplier.firstname + ' ' + task.supplier.lastname}
          />

          <Chip>Supplier</Chip>
        </div>

        <Chat
          messages={supplierMsgs || []}
          onSend={onSupplierMsg}
        />
      </div>
    </div>
  )
}
